import { RgbColor } from "../data/RgbColor";

export var Colors = {
    RED: new RgbColor(255, 0, 0),
    BLUE: new RgbColor(0, 0, 255),
    GREEN: new RgbColor(0, 255, 0),
    BLACK: new RgbColor(0, 0, 0),
    WHITE: new RgbColor(255, 255, 255),
}